<template>
  <header class="jps-cs-header jps-list-header" v-if="cs" role="group">
    <h1 class="jps-lh-title">
      <BaseIcon v-if="isJps" :name="autoKoicon(cs.name?.ja)" class="icon" size="size-full" />
      <span class="jps-lh-title-span">{{ ls(cs.name) }}</span>
    </h1>
    <p
      class="jps-lh-description"
    >
      {{ ls(cs.description) }}
      <UiButtonIcon
        tag="button"
        class="jps-icon-button"
        v-if="hasHelp && !isImageCsearch"
        icon="mdi/help-circle-outline"
        icon-size="size-5"
        @click="showHelp = !showHelp"
      />
    </p>
    <Transition name="fade">
      <DeltaRenderer
        class="cs-help jps-message jps-blue generated-23"
        v-if="displayHelp"
        :delta="ld(cs.help)"
      />
    </Transition>
    <div v-if="showSample" class="sample-query">
      <dl>
        <dt>
          {{ ls({ ja: '例', en: 'Example ' }) }}
        </dt>
        <dd v-for="query in cs.sampleQuery" :key="query.name.ja">
          <BaseLink :to="searchTo(query)">{{
            ls(query.name)
          }}</BaseLink>
        </dd>
      </dl>
    </div>
  </header>
</template>

<script lang="ts" setup>
const { ls, ld } = useI18n()
const { isJps } = useServiceType()
const route = useRoute()

interface Props {
  cs: CustomSearchDefinition
}
const props = withDefaults(defineProps<Props>(), {})

//data
const showHelp: Ref<boolean> = ref(false)

const showSample = computed(() => {
  return !isEmpty(props.cs.sampleQuery)
})

const isImageCsearch = computed(() => {
  return route?.params?.csId === systemImageSearchId()
})

const displayHelp = computed(() => {
  if (isImageCsearch.value) return hasHelp.value
  return showHelp.value
})

const hasHelp = computed(() => {
  return props.cs.help && !isEmptyDelta(props.cs.help.ja)
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-cs-header {
  @include base-content-width();
  margin-bottom: 1.5rem;
  .jps-lh-title {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;

    .icon {
      max-width: 1.25rem;
      max-height: 1.25rem;
      @include is-tablet {
        max-width: 2rem;
        max-height: 2rem;
      }
    }
  }
  .jps-lh-description {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    text-align: center;
    .jps-icon-button {
      &::before {
        line-height: 24px;
      }
    }
  }
  .jps-title {
    display: flex;
    align-items: center;
    .jps-icon {
      margin-right: calc(0.25rem * 4);
    }
  }
  .cs-description,
  .cs-help,
  .sample-query {
    display: flex;
    justify-content: center;
    font-size: 0.75rem;
    line-height: 1rem;
  }
  .sample-query {
    dl {
      display: flex;
      align-items: center;
      gap: 0 0.5rem;
      dt {
        font-size: 0.75rem;
        display: flex;
        align-items: center;
        line-height: 1rem;
      }
      dd {
        margin-left: calc(0.25rem * 2);
        a {
          font-size: 0.75rem;
          line-height: 1rem;
          text-decoration-line: none;
        }
      }
    }
  }
}
</style>
